<style lang="less" scoped>
.class-info{
  margin:30px 50px;
  font-size:18px;
  .content{
    font-size:1.1em;
    font-weight: bold;
    margin-bottom:10px;
    padding:10px 0;
    // border-bottom:1px solid #EEE;
    /deep/.ant-input{
      border: none;
      width: 70%;
      font-size:1.1em;
      font-weight: bold;
      padding-left: 0px;
      background: #fff;
      color:#000;
    }
  }
  .edit{
    width: 80px;
    height:32px;
    border-radius:20px;
    color: #fff;
    font-size: 16px;
    background: @primary-color;
    float: right;
  }
  .out{
    margin-top: 20px;
    text-align: center;
    color:#db5647;
    font-size: 16px;
    cursor: pointer;
  }
}
</style>
<template>
  <div class="class-info">
    <div>小组名</div>
    <div class="content">
      <!-- <span>{{classInfo.groupName}}</span> -->
      <a-input ref="input" v-model="classInfo.groupName"  :disabled="editAble" @blur="editComplete"/>
      <a-button class="edit" @click="editFun">编辑</a-button>
    </div>
    <!-- <div>班级ID</div>
    <div group="content">{{classInfo.classId}}</div>
    <div>班级二维码</div>
    <div group="content" ref="qrcode"></div> -->
    <div class="out">
      <a-button type="danger" @click="deleteClassGroup">解散小组群</a-button>
    </div>
  </div>

</template>

<script>
import QRCode from 'qrcodejs2'
import shareState from 'utils/shareState.js'
export default {
  name: 'ClassInfo1',
  data () {
    return {
      shareData: shareState.state,
      classInfo: {},
      groupid: '',
      className: '',
      qrcode: null,
      editAble: true
    }
  },
  watch: {
    $route () {
      this.getClassInfo()
    }
  },
  mounted () {
    this.getClassInfo()
    console.log(this.shareData.groupLists)
    console.log(this.shareData.imGroupList)
  },
  methods: {
    getClassInfo () {
      this.groupid = this.$route.params.groupid
      // const myClass = this.$getUserInfo().group.filter(c => c.groupid === this.groupid)
      // const myClass = JSON.parse(localStorage.getItem('newClassInfo')).filter(c => c.groupTag === this.groupid)
      // const myClass = this.shareData.classInfo
      // if (myClass.length === 0) {
      //   if(this.shareData.imGroupList){
      //     const myGroup = this.shareData.imGroupList.filter(g => g.groupTag === this.groupid)
      //     this.classInfo = myGroup.length > 0 ? myGroup[0] : {}
      //     this.className = this.classInfo.className||this.classInfo.groupname
      //   }
      // } else {
      //   this.classInfo = myClass[0]
      //   this.className = this.classInfo.className||this.classInfo.groupname
      // }
      // this.creatQrCode(this.classInfo.id || this.classInfo.groupid)
      // const myClass = this.shareData.imGroupList
      const myGroup = this.shareData.imGroupList.filter(g => g.groupTag === this.groupid)
      this.classInfo = myGroup.length > 0 ? myGroup[0] : {}
    },
    creatQrCode (id) {
      if (this.qrcode) {
        this.qrcode.clear()
        this.qrcode.makeCode(id)
        return
      }
      this.qrcode = new QRCode(this.$refs.qrcode, {
        text: id, // 需要转换为二维码的内容
        width: 130,
        height: 130,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    editFun () {
      this.editAble = false
      this.$nextTick(() => {
        this.$refs.input.focus()
      }, 50)
    },
    editComplete () { // 编辑名称
      this.editAble = true
      const _this = this
      const param = {
        groupId: _this.classInfo.id,
        groupName: _this.classInfo.groupName
      }
      if (_this.classInfo.groupName.length > 8) {
        this.$message.warning('小组名称应在8个字以内')
        return false
      }
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/class/common/editClassGroup',
        body: param
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          _this.$message.success('更改名字成功')
        }
      })
    },
    deleteClassGroup () {
      const _this = this
      _this.$confirm({
        title: '解散小组',
        content: '您确认解散小组吗？',
        okText: '确认',
        cancelText: '取消',
        onOk () {
          return new Promise((resolve, reject) => {
            _this
              .$fetch({
                url: _this.$baseUrl + 'ebook/class/common/deleteClassGroup',
                body: { groupId: _this.classInfo.id }
              })
              .done((res) => {
                resolve(res)
              })
          }).then((res) => {
            if (res && res.success && res.resultCode === 0) {
              console.log(_this.shareData.imGroupList)
              console.log(_this.classInfo.groupTag)
              const grouplist = _this.shareData.imGroupList.filter(c => c.groupTag !== _this.classInfo.groupTag)
              console.log(grouplist)
              _this.$store.commit('setGroupLists', grouplist)
              // _this.shareData.setImGroupList(grouplist)
              _this.$message.success('解散小组成功')

              _this.$router.push({ path: '/accompanyStudy/group/chat/undefined' });
              _this.$forceUpdate()
              // _this.$router.push({ name: 'AccompanyStudy' })
              // _this.$router.go(0)
              // const myGroup = this.shareData.imGroupList.filter(g => g.groupTag === this.groupid)
              // this.classInfo = myGroup.length > 0 ? myGroup[0] : {}
            }
          })
        },
        onCancel () {
        }
      })
    }
  }
}
</script>
